export default __webpack_public_path__ + "static/media/4.8336e4a8.mp3";